import SystemRoleList from "./SystemRoleList";
import SystemRoleAssignPermission from "./SystemRoleAssignPermission";

export default {
  list: SystemRoleList,
  show: SystemRoleAssignPermission,
};
